<template>
  <div class="p-0 flex flex-col items-center justify-start min-h-[75vh]">
    <div class="container max-w-screen-lg mx-auto">
      <div>
        <div class="bg-white rounded shadow-lg p-4 px-4 md:p-8 mb-6">
          <div class="grid gap-4 gap-y-2 text-sm grid-cols-1 lg:grid-cols-3">
            <div class="text-left block mb-4">
              <p class="mb-2 font-medium text-lg text-gray-900">
                {{ descriptionTitle }}
              </p>
              <p class="text-gray-500">
                Campos com <span class="text-red-500">*</span> são obrigatórios
              </p>

              <div class="flex justify-center" :key="store.state.events.banner">
                <img
                  v-if="selectedFileUrl || store.state.events.banner"
                  :src="selectedFileUrl ?? fileUrl + store.state.events.banner"
                  alt="Banner do evento"
                  class="mt-10 mb-auto rounded-md w-60 max-h-60 hidden md:block"
                />
              </div>
            </div>

            <div id="form-fields" class="lg:col-span-2 space-y-6 text-start">
              <div class="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-5">

                <!-- dados do evento -->
                <div
                  @click="toggleEventsTab"
                  class="cursor-pointer md:col-span-5"
                >
                  <div
                    class="flex justify-between items-center bg-gray-100 rounded p-1"
                  >
                    <label class="font-medium text-lg text-gray-800 p-1 -ml-1">
                      DETALHES DO EVENTO
                    </label>
                    <component
                      :is="PhCaretUp"
                      class="w-6 h-6 transition-all"
                      :class="{ 'rotate-180': eventsTab }"
                    ></component>
                  </div>
                </div>

                <div class="md:col-span-5">
                  <Transition mode="out-in">
                    <div
                      v-show="eventsTab"
                      class="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-5"
                    >
                      <!-- titulo -->
                      <div class="md:col-span-3">
                        <BaseInput
                          type="text"
                          name="title"
                          v-model="store.state.events.title"
                          label="Titulo"
                          :info="'Informe o titulo do evento'"
                          :required-field="true"
                          :activeDefault="false"
                        >
                          <template #append>
                            <CleanInputButton @click="store.state.events.title = null" />
                          </template>
                        </BaseInput>

                        <span
                          name="events.title"
                          class="text-red-600 text-sm"
                        />
                      </div>

                      <!-- date -->
                      <div class="md:col-span-2">
                        <BaseInput
                          type="date"
                          name="date"
                          v-model="store.state.events.date"
                          label="Data do evento"
                          :info="'Informe a data do evento'"
                          :required-field="false"
                          :activeDefault="true"
                        >
                          <template #append>
                            <CleanInputButton @click="store.state.events.date = null" />
                          </template>
                        </BaseInput>
                      </div>

                      <!-- description -->
                      <div class="md:col-span-5">
                        <div class="md:col-span-2 mt-1.5">
                          <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.employee">
                            Descrição <a class="text-red-600 ml-1">*</a>
                          </label>
                          <div
                            class="mx-1 mt-2"
                          >
                            <textarea
                              name="description"
                              v-model="store.state.events.description"
                              class=" input-field"
                            >
                            </textarea>
                          </div>
                        </div>
                      </div>

                      <!-- location -->
                      <div class="md:col-span-3">
                        <BaseInput
                          type="text"
                          name="location"
                          v-model="store.state.events.location"
                          label="Local"
                          :info="'Local do evento'"
                          :required-field="false"
                          :activeDefault="false"
                        >
                          <template #append>
                            <CleanInputButton @click="store.state.events.location = null" />
                          </template>
                        </BaseInput>
                      </div>

                      <!-- tag -->
                      <div class="md:col-span-2">
                        <BaseInput
                          type="text"
                          name="tag"
                          v-model="store.state.events.tag"
                          label="CARD"
                          :info="'CARD do evento'"
                          :required-field="false"
                          :activeDefault="false"
                        >
                          <template #append>
                            <CleanInputButton @click="store.state.events.tag = null" />
                          </template>
                        </BaseInput>
                      </div>
                    </div>
                  </Transition>
                </div>

                <!-- links e privacidade -->
                <div
                  @click="togglePrivacityTab"
                  class="cursor-pointer md:col-span-5"
                >
                  <div
                    class="flex justify-between items-center bg-gray-100 rounded p-1"
                  >
                    <label class="font-medium text-lg text-gray-800 p-1 -ml-1">
                      LINKS E PRIVACIDADE
                    </label>
                    <component
                      :is="PhCaretUp"
                      class="w-6 h-6 transition-all"
                      :class="{ 'rotate-180': linksPrivacityTab }"
                    ></component>
                  </div>
                </div>

                <div class="md:col-span-5">
                  <Transition mode="out-in">
                    <div
                      v-show="linksPrivacityTab"
                      class="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-5"
                    >
                      <!-- is_live -->
                      <div class="md:col-span-2">
                        <div class="md:col-span-2 mt-1.5">
                          <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.employee">
                            Este é um evento ao vivo? <a class="text-red-600 ml-1">*</a>
                          </label>
                          <div
                            class="h-10 flex rounded items-center"
                          >
                            <SimpleSelect
                              class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent text-center"
                              :data="yesOrNo"
                              :disable-keyboard="true"
                              :initial-value="store.state.events.is_live == 1 ? { name: 'SIM', value: true } : { name: 'NÃO', value: false }"
                              @selected-data="(val) => (store.state.events.is_live = val.value)"
                            />
                          </div>
                        </div>

                        <span
                          name="events.is_live"
                          class="text-red-600 text-sm"
                        />
                      </div>

                      <!-- youtube_video_id -->
                      <div class="md:col-span-3">
                        <Transition mode="out-in">
                          <div :key="store.state.events.is_live" v-if="store.state.events.is_live == true">
                            <BaseInput
                              type="text"
                              name="form.realizado_em"
                              v-model="store.state.events.youtube_video_id"
                              label="Link"
                              :info="'Informe o link do evento'"
                              :required-field="false"
                              :activeDefault="true"
                            >
                              <template #append>
                                <CleanInputButton @click="store.state.events.youtube_video_id = null" />
                              </template>
                            </BaseInput>
                          </div>
                        </Transition>
                      </div>

                      <!-- is_private -->
                      <div class="md:col-span-3">
                        <div class="md:col-span-2 mt-1.5">
                          <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.employee">
                            Este é um evento privado? <a class="text-red-600 ml-1">*</a>
                          </label>
                          <div
                            class="h-10 flex rounded items-center"
                          >
                            <SimpleSelect
                              class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent text-center"
                              :data="yesOrNo"
                              :disable-keyboard="true"
                              :initial-value="store.state.events.is_private == 1 ? { name: 'SIM', value: true } : { name: 'NÃO', value: false }"
                              @selected-data="(val) => (store.state.events.is_private = val.value)"
                            />
                          </div>
                          <span
                            name="events.is_private"
                            class="text-red-600 text-sm"
                          />
                        </div>
                      </div>

                      <!-- requires_payment -->
                      <div class="md:col-span-2">
                        <div class="md:col-span-2 mt-1.5">
                          <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.employee">
                            Este é um evento gratuito? <a class="text-red-600 ml-1">*</a>
                          </label>
                          <div
                            class="h-10 flex rounded items-center"
                          >
                            <SimpleSelect
                              class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent text-center"
                              :data="yesOrNo"
                              :disable-keyboard="true"
                              :initial-value="store.state.events.requires_payment == 1 ? { name: 'SIM', value: true } : { name: 'NÃO', value: false }"
                              @selected-data="(val) => (store.state.events.requires_payment = val.value)"
                            />
                          </div>
                          <span
                            name="events.requires_payment"
                            class="text-red-600 text-sm"
                          />
                        </div>
                      </div>

                      <!-- allows_sponsorship -->
                      <div class="md:col-span-2">
                        <div class="md:col-span-2 mt-1.5">
                          <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.employee">
                            Permitir patrocinadores?
                          </label>
                          <div
                            class="h-10 flex rounded items-center"
                          >
                            <SimpleSelect
                              class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent text-center"
                              :data="yesOrNo"
                              :disable-keyboard="true"
                              :initial-value="store.state.events.allows_sponsorship == 1 ? { name: 'SIM', value: true } : { name: 'NÃO', value: false }"
                              @selected-data="(val) => (store.state.events.allows_sponsorship = val.value)"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </Transition>
                </div>

                <!-- valores -->
                <div
                  @click="toggleValuesTab"
                  class="cursor-pointer md:col-span-5"
                >
                  <div
                    class="flex justify-between items-center bg-gray-100 rounded p-1"
                  >
                    <label class="font-medium text-lg text-gray-800 p-1 -ml-1">
                      VALORES E DATAS
                    </label>
                    <component
                      :is="PhCaretUp"
                      class="w-6 h-6 transition-all"
                      :class="{ 'rotate-180': valuesTab }"
                    ></component>
                  </div>
                </div>

                <div class="md:col-span-5">
                  <Transition mode="out-in">
                    <div
                      v-show="valuesTab"
                      class="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-5"
                    >
                      <!-- price -->
                      <div class="md:col-span-3">
                        <BaseInput
                          type="text"
                          name="price"
                          v-model="store.state.events.price"
                          label="Valor R$"
                          :disabled="store.state.events.requires_payment == false ? false : true"
                          @input="formatCurrency"
                          :info="'Valor R$'"
                          :required-field="true"
                          :activeDefault="false"
                        >
                          <template #append>
                            <CleanInputButton @click="store.state.events.price = null" />
                          </template>
                        </BaseInput>
                      </div>

                      <!-- amount - qtd-->
                      <div class="md:col-span-2">
                        <BaseInput
                          type="number"
                          name="amount"
                          v-model="store.state.events.amount"
                          label="Quantidade de ingressos"
                          :info="'Ingressos disponiveis'"
                          :required-field="false"
                          :activeDefault="false"
                        >
                          <template #append>
                            <CleanInputButton @click="store.state.events.amount = null" />
                          </template>
                        </BaseInput>
                      </div>

                      <!-- starts_at -->
                      <div class="md:col-span-2">
                        <BaseInput
                          type="datetime-local"
                          name="starts_at"
                          v-model="store.state.events.starts_at"
                          label="Inicio do evento"
                          :info="'Inicio do evento'"
                          :required-field="true"
                          :activeDefault="true"
                        >
                          <template #append>
                            <CleanInputButton @click="store.state.events.starts_at = null" />
                          </template>
                        </BaseInput>

                        <span
                          name="events.starts_at"
                          class="text-red-600 text-sm"
                        />
                      </div>

                      <!-- ends_at -->
                      <div class="md:col-span-2">
                        <BaseInput
                          type="datetime-local"
                          name="ends_at"
                          v-model="store.state.events.ends_at"
                          label="Fim do evento"
                          :info="'Fim do evento'"
                          :required-field="false"
                          :activeDefault="true"
                        >
                          <template #append>
                            <CleanInputButton @click="store.state.events.ends_at = null" />
                          </template>
                        </BaseInput>
                      </div>

                    </div>
                  </Transition>
                </div>

                <!-- participantes -->
                <div
                  @click="toggleParticipantsTab"
                  class="cursor-pointer md:col-span-5"
                >
                  <div
                    class="flex justify-between items-center bg-gray-100 rounded p-1"
                  >
                    <label class="font-medium text-lg text-gray-800 p-1 -ml-1">
                      PARTICIPANTES
                    </label>
                    <component
                      :is="PhCaretUp"
                      class="w-6 h-6 transition-all"
                      :class="{ 'rotate-180': this.participantsTab }"
                    ></component>
                  </div>
                </div>

                <div class="md:col-span-5">
                  <Transition mode="out-in">
                    <div
                      v-show="this.participantsTab"
                      class="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-5"
                    >
                      <!-- fighters -->
                      <div class="md:col-span-5">
                        <div class="md:col-span-2 mt-1.5">
                          <label
                            class="text-left flex pl-1 text-xs text-[#2b3038]"
                            for="relatosForm.empresa"
                          >
                            Lutadores
                          </label>
                          <div class="h-10 flex rounded items-center">
                            <SimpleSelect
                              class="px-1 py-2 text-center uppercase appearance-none outline-none text-gray-800 w-full bg-transparent"
                              :key="clearOnSelected"
                              :data="fighters"
                              :disable-keyboard="true"
                              @selected-data="
                                (val) => store.state.selectedFighter = val
                              "
                            />
                          </div>
                        </div>
                      </div>

                      <div class="md:col-span-5">
                        <div class="grid gap-4 gap-y-2 text-sm grid-cols-5">
                          <!-- r$ -->
                          <div class="md:col-span-2 col-span-2">
                            <BaseInput
                              name="amount"
                              v-model="store.state.events.descAmount"
                              :required-field="false"
                              :info="'Desconto em R$'"
                              label="Desconto em R$"
                              type="text"
                              @input="formatDescAmount"
                            >
                              <template #append>
                                <CleanInputButton
                                  @click="store.state.events.descAmount = undefined"
                                />
                              </template>
                            </BaseInput>
                          </div>

                          <!-- % -->
                          <div class="md:col-span-2 col-span-2">
                            <BaseInput
                              name="percent"
                              v-model="store.state.events.descPorcent"
                              :required-field="false"
                              :info="'Desconto em %'"
                              label="Desconto em %"
                              type="number"
                              :min="1"
                              :max="99"
                            >
                              <template #append>
                                <CleanInputButton
                                  @click="store.state.events.descPorcent = undefined"
                                />
                              </template>
                            </BaseInput>

                            <span name="percent" class="text-red-600 text-sm" />
                          </div>

                          <div class="col-span-1">
                            <div class="h-full">
                              <button
                                @click="addIntegrante"
                                title="Adicionar integrante"
                                class="px-2 py-2 bg-gradient-to-r to-[#93cd24] from-[#0c7036] mt-3 text-white rounded-full hover:cursor-pointer transition-all hover:scale-105 text-center flex justify-center"
                              >
                                <component class="w-8 h-8" :is="PhUserPlus"></component>
                              </button>
                            </div>
                          </div>
                        </div>

                        <!-- Lista de Integrantes -->
                        <div class="mt-3 w-full max-h-[20vh] overflow-auto">
                          <h3 class="text-lg font-semibold text-start sticky top-0 bg-white p-1">
                            Integrantes adicionados: {{ store.state.events.integrantes?.length }}
                          </h3>
                          <ul class="flex flex-wrap" v-if="store.state.events.integrantes?.length">
                            <li
                              v-for="(integrante, index) in store.state.events.integrantes"
                              :key="index"
                              class="flex justify-between bg-gray-100 p-2 rounded-md m-1"
                            >
                              <label>
                                <label class="font-bold uppercase">
                                  <small class="text-gray-400 font-normal lowercase">
                                    lutador:
                                  </small>
                                  {{
                                    integrante.nome?.length > 20
                                    ? integrante.nome.slice(0, 20).concat('...')
                                    : integrante.nome
                                  }} <br>
                                </label>

                                <label class="font-bold text-green-500" v-if="integrante?.descAmount">
                                  <small class="text-gray-400 font-normal">
                                    desconto de:
                                  </small> {{ integrante?.descAmount }} <br>
                                </label>

                                <label class="font-bold text-green-500" v-if="integrante?.descPorcent">
                                  <small class="text-gray-400 font-normal">
                                    desconto de:
                                  </small> {{ integrante?.descPorcent }}% <br>
                                </label>
                              </label>
                              <button
                                @click="removeIntegrante(index, integrante.id)"
                                class="text-red-500 hover:text-red-700 flex px-1"
                              >
                                <component :is="PhX" class="w-5 h-5 rounded-full bg-white p-0.5"></component>
                              </button>
                            </li>
                          </ul>
                        </div>

                      </div>

                    </div>
                  </Transition>
                </div>

                <!-- fluxo da imagem -->
                <div class="flex justify-center">
                  <img
                    v-if="selectedFileUrl || store.state.events.banner"
                    :src="selectedFileUrl ?? fileUrl + store.state.events.banner"
                    alt="Banner do evento"
                    class="mt-2 rounded-md w-60 max-h-60 block md:hidden"
                  />
                </div>

                <div class="md:col-span-5 md:-mt-1 flex h-10">
                  <label
                    class="cursor-pointer bg-gray-100 hover:bg-gray-300 transition-all min-w-[8rem] h-10 rounded-l-md rounded-r-none"
                  >
                    <div class="flex mt-auto mb-auto h-full">
                      <div class="w-full mt-auto mb-auto flex justify-center">
                        <component
                          :is="selectedFileName ? image : fileImage"
                          class="w-5 h-5 mr-1"
                          :class="[
                            selectedFileName ? 'text-green-500' : 'text-gray-500'
                          ]"
                        />

                        Banner
                      </div>
                    </div>
                    <input
                      type="file"
                      class="hidden"
                      @change="handleFileChange"
                    />
                  </label>
                  <input
                    type="text"
                    style="padding-left: 10px !important"
                    class="border rounded w-full h-10 rounded-r-md rounded-l-none"
                    :value="selectedFileName"
                  />

                </div>
              </div>
            </div>
          </div>

          <!-- Botão de Salvar -->
          <div class="text-right flex justify-center mt-8">
            <slot />
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SimpleSelect from '@/components/Select/SimpleSelect.vue'
import CleanInputButton from '../utils/CleanInputButton.vue'
import BaseInput from '@/components/Inputs/BaseInput.vue'
import BlogEditor from '@/components/BlogEditor.vue'
import { sectorPriority, yesOrNo } from '../lookups/form'
import { dataEvent } from '../store'
import { PhCaretUp, PhFileImage, PhImage, PhUserPlus, PhX } from '@phosphor-icons/vue'
import { showToast as toast } from '@/helpers/UseToasts'

import { computed } from 'vue'
import EventService from '../service/event.service'

export default {
  components: {
    SimpleSelect,
    CleanInputButton,
    BaseInput,
    BlogEditor
  },
  props: {
    descriptionTitle: String,
    create: Boolean
  },
  data () {
    const fileUrl = process.env.VUE_APP_IMAGE_SERVE + 'storage/'
    const store = dataEvent
    const fighters = computed(() => dataEvent.getters.getAllFighters)

    return {
      PhCaretUp,
      PhUserPlus,
      PhX,
      yesOrNo,

      fileImage: PhFileImage,
      image: PhImage,
      selectedFileName: undefined,
      selectedFileUrl: undefined,
      dataEvent,
      sectorPriority,
      fileUrl,
      toast,
      store,
      fighters,

      rawPrice: null,

      eventsTab: true,
      valuesTab: false,
      participantsTab: true,
      linksPrivacityTab: false,

      clearOnSelected: 0
    }
  },
  methods: {
    formatCurrency (event) {
      const onlyDigits = event.target.value.replace(/\D/g, '')
      const formatted = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(onlyDigits / 100)

      this.store.state.events.price = formatted
    },
    formatDescAmount (event) {
      const onlyDigits = event.target.value.replace(/\D/g, '')
      const formatted = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(onlyDigits / 100)

      this.store.state.events.descAmount = formatted
    },
    toggleEventsTab () {
      this.valuesTab = false
      this.linksPrivacityTab = false

      this.eventsTab = !this.eventsTab
    },
    toggleValuesTab () {
      this.linksPrivacityTab = false
      this.eventsTab = false

      this.valuesTab = !this.valuesTab
    },
    togglePrivacityTab () {
      this.valuesTab = false
      this.eventsTab = false

      this.linksPrivacityTab = !this.linksPrivacityTab
    },
    toggleParticipantsTab () {
      this.valuesTab = false
      this.eventsTab = false
      this.linksPrivacityTab = false

      this.participantsTab = !this.participantsTab
    },
    addIntegrante () {
      const id = this.store.state.selectedFighter?.value
      const nome = this.store.state.selectedFighter?.name?.trim()
      const descAmount = this.store.state.events.descAmount?.trim()
      const descPorcent = this.store.state.events.descPorcent?.trim()

      if (!nome) {
        alert('Informe um lutador antes de adicionar.')
        return
      }

      this.store.commit('ADD_INTEGRANTE', {
        id,
        nome,
        descAmount,
        descPorcent
      })

      // Limpa os campos
      this.store.state.selectedFighter = null
      this.store.state.events.descAmount = ''
      this.store.state.events.descPorcent = ''

      this.clearOnSelected++
    },
    removeIntegrante (index, cId) {
      this.store.state.events.integrantes.splice(index, 1)

      if (!this.create) {
        Promise.allSettled([
          EventService.removeFighter(cId, this.store.state.events?.id)
            .then(res => {
              console.log(res.data)
            }).catch(err => {
              if (err?.response?.data?.error && err.response.data.status === 400) {
                return toast(
                  'Aviso',
                  err.response.data.message,
                  'error'
                )
              }

              if (err?.response?.data?.error && err.response.data.status === 404) {
                return toast(
                  'Aviso',
                  err.response.data.message,
                  'error'
                )
              }

              return toast(
                'Aviso',
                'Algo deu errado com sua solicitação',
                'error'
              )
            })
        ])
      }
    },

    handleFileChange (event) {
      const file = event.target.files[0]
      if (file) {
        const allowedExtensions = ['webp', 'png', 'gif', 'jpeg', 'jpg']
        const fileExtension = file.name.split('.').pop().toLowerCase()
        if (allowedExtensions.includes(fileExtension)) {
          this.selectedFileName = file.name
          this.selectedFileUrl = URL.createObjectURL(file)
          this.store.state.events.banner = file
        } else {
          return this.toast(
            'Atenção',
            'Apenas imagens do tipo: webp, png, gif, jpeg e jpg são aceitas',
            'info'
          )
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.input-field {
  display: block;
  width: 100%;
  padding: 10px;
  font-size: 16px;
  border-radius: 10px;
  border: 2px solid #ccc;
  outline: none;
  background-color: transparent;
  transition: border-color 0.3s ease-in-out;
}
</style>
